import { render, staticRenderFns } from "./noteCheck.vue?vue&type=template&id=55c9544d&scoped=true&"
import script from "./noteCheck.vue?vue&type=script&lang=js&"
export * from "./noteCheck.vue?vue&type=script&lang=js&"
import style0 from "./noteCheck.vue?vue&type=style&index=0&id=55c9544d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c9544d",
  null
  
)

export default component.exports